export enum Days {
    Sunday = "Dim",
    Monday = "Lun",
    Tuesday = "Mar",
    Wednesday = "Mer",
    Thursday = "Jeu",
    Friday = "Ven",
    Saturday = "Sam",
}